import { useEffect, useRef } from 'react';

// L'accueil reste vivant : `refresh` tourne toutes les `intervalMs` tant que l'onglet est visible, et tout de suite
// quand on y revient (après plus de `minGapMs`). Rien ne tourne dans un onglet caché.
const useLivePolling = (refresh, intervalMs, { enabled = true, minGapMs = 10000 } = {}) => {
  const last = useRef(Date.now());
  const callback = useRef(refresh);
  callback.current = refresh;

  useEffect(() => {
    if (!enabled) return undefined;
    const run = () => {
      last.current = Date.now();
      callback.current();
    };
    const timer = setInterval(() => {
      if (document.visibilityState === 'visible') run();
    }, intervalMs);
    const onVisible = () => {
      if (document.visibilityState === 'visible' && Date.now() - last.current > minGapMs) run();
    };
    document.addEventListener('visibilitychange', onVisible);
    window.addEventListener('focus', onVisible);
    return () => {
      clearInterval(timer);
      document.removeEventListener('visibilitychange', onVisible);
      window.removeEventListener('focus', onVisible);
    };
  }, [enabled, intervalMs, minGapMs]);
};

export default useLivePolling;
